import { createAsyncThunk } from '@reduxjs/toolkit';
import { operationsSearch } from '@reducers/search';
import { AppDispatch, RootState } from '@store/types';

export const fetchNoMachineColumnCount = createAsyncThunk<{ totalCount: number; linkedCount: number }, { filter: string }, { dispatch: AppDispatch }>(
  'planboard/fetchNoMachineColumnCount',
  async ({ filter }, { dispatch, getState }) => {
    const searchValue = (getState() as RootState).planboard.searchValue;

    // Filter for operations not scheduled on any machine
    const linkedOperationsFilter = `Status ne 'Finished' and Status ne 'Running' and not Machines/any(machine: machine/LinkType eq 'ScheduledOn')${
      filter ? ` and (${filter})` : ''
    }`.trim();
    const allOperationsFilter = `Status ne 'Finished' and Status ne 'Running' and not Machines/any(machine: machine/LinkType eq 'ScheduledOn')`;

    const [allOperationsResponse, linkedOperationsResponse] = await Promise.all([
      dispatch(
        operationsSearch({
          data: { top: 0, search: searchValue },
          filter: { oDataFilter: allOperationsFilter },
          resetHistory: true,
          ignoreHistory: true,
        })
      ),
      dispatch(
        operationsSearch({
          data: { top: 0, search: searchValue },
          filter: { oDataFilter: linkedOperationsFilter },
          resetHistory: true,
          ignoreHistory: true,
        })
      ),
    ]);

    return { linkedCount: linkedOperationsResponse?.totalResultCount ?? 0, totalCount: allOperationsResponse?.totalResultCount ?? 0 };
  }
);
